import { SET_PERMISSIONS } from "../../types/index";

export default (state, action) => {
  switch (action.type) {
    case SET_PERMISSIONS:
      return;

    default:
      break;
  }
};
